import React from 'react';
import { CopyToClipboardButton } from '@cko/primitives';
import { LabelText, RowContainer, ValueText } from './Row.styles';

type RowProps = {
  label: string;
  value: string;
};

export const Row = ({ label, value }: RowProps) => (
  <RowContainer>
    <LabelText>{label}</LabelText>
    <ValueText>{value}</ValueText>
    <CopyToClipboardButton label={label} value={value} />
  </RowContainer>
);
